import { render, staticRenderFns } from "./settingBusinessUnitTypes.vue?vue&type=template&id=4771db46&scoped=true&"
import script from "./settingBusinessUnitTypes.vue?vue&type=script&lang=js&"
export * from "./settingBusinessUnitTypes.vue?vue&type=script&lang=js&"
import style0 from "./settingBusinessUnitTypes.vue?vue&type=style&index=0&id=4771db46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771db46",
  null
  
)

export default component.exports